import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getPaymentMethod } from '../../../actions/user.actions';
import { selectUser } from '../../../reducers/user.selectors';
import useAction from '../../../utils/useAction';
import AccountPage from '../../AccountPage';

const PersonalDetailsAccountSection: React.FC = () => {
	const user = useSelector(selectUser);
	const getPaymentMethodAction = useAction(getPaymentMethod);

	// biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome hook deps kept as-is; changing the deps list alters effect timing
	useEffect(() => {
		getPaymentMethodAction();
	}, [user?.id]);

	return <AccountPage />;
};

export default PersonalDetailsAccountSection;
